import React from "react";

import KritikSaranStatusBadge from "./KritikSaranStatusBadge";

const KritikSaranTimeline = ({
  kritikSaran = {},
}) => {
  /*
  |--------------------------------------------------------------------------
  | DATA
  |--------------------------------------------------------------------------
  */

  const disposisi =
    kritikSaran.disposisi || [];

  const tindakLanjut =
    kritikSaran.tindak_lanjut || [];

  return (
    <>
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-primary text-white">
          <div className="fw-semibold">
            Timeline Kritik & Saran
          </div>
        </div>

        <div className="card-body">
          {/* KRITIK SARAN */}
          <div className="d-flex mb-4">
            {/* ICON */}
            <div
              className="me-3 d-flex justify-content-center align-items-start"
              style={{
                width: "40px",
              }}
            >
              <div
                className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
                style={{
                  width: "35px",
                  height: "35px",
                }}
              >
                <i className="fa fa-paper-plane" />
              </div>
            </div>

            {/* CONTENT */}
            <div className="flex-grow-1">
              <div className="fw-semibold">
                Kritik & Saran Dibuat
              </div>

              <div className="small text-muted mb-2">
                {kritikSaran.created_at}
              </div>

              <div className="border rounded p-3 bg-light">
                <div className="fw-semibold mb-1">
                  {kritikSaran.judul}
                </div>

                <div className="mb-2">
                  {kritikSaran.isi}
                </div>

                <KritikSaranStatusBadge
                  status={kritikSaran.status}
                />
              </div>
            </div>
          </div>

          {/* DISPOSISI */}
          {disposisi.length > 0 &&
            disposisi.map((d, index) => {
              return (
                <div
                  className="d-flex mb-4"
                  key={index}
                >
                  {/* ICON */}
                  <div
                    className="me-3 d-flex justify-content-center align-items-start"
                    style={{
                      width: "40px",
                    }}
                  >
                    <div
                      className="rounded-circle bg-info text-white d-flex justify-content-center align-items-center"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <i className="fa fa-share" />
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="flex-grow-1">
                    <div className="fw-semibold">
                      Disposisi
                    </div>

                    <div className="small text-muted mb-2">
                      {d.created_at}
                    </div>

                    <div className="border rounded p-3">
                      <div className="mb-1">
                        <strong>
                          Penerima :
                        </strong>{" "}
                        {d.penerima_type} #
                        {d.penerima_id}
                      </div>

                      {d.group && (
                        <div className="mb-1">
                          <strong>
                            Group :
                          </strong>{" "}
                          {d.group}
                        </div>
                      )}

                      {d.catatan && (
                        <div className="mt-2">
                          {d.catatan}
                        </div>
                      )}

                      <div className="mt-2">
                        {d.status_proses ===
                          "menunggu" && (
                          <span className="badge bg-secondary">
                            Menunggu
                          </span>
                        )}

                        {d.status_proses ===
                          "diproses" && (
                          <span className="badge bg-warning text-dark">
                            Diproses
                          </span>
                        )}

                        {d.status_proses ===
                          "selesai" && (
                          <span className="badge bg-success">
                            Selesai
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

          {/* TINDAK LANJUT */}
          {tindakLanjut.length > 0 &&
            tindakLanjut.map((t, index) => {
              return (
                <div
                  className="d-flex mb-4"
                  key={index}
                >
                  {/* ICON */}
                  <div
                    className="me-3 d-flex justify-content-center align-items-start"
                    style={{
                      width: "40px",
                    }}
                  >
                    <div
                      className="rounded-circle bg-success text-white d-flex justify-content-center align-items-center"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <i className="fa fa-reply" />
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="flex-grow-1">
                    <div className="fw-semibold">
                      Tindak Lanjut
                    </div>

                    <div className="small text-muted mb-2">
                      {t.created_at}
                    </div>

                    <div className="border rounded p-3">
                      <div className="mb-1">
                        <strong>
                          User :
                        </strong>{" "}
                        {t.user_type} #
                        {t.user_id}
                      </div>

                      <div className="mb-2">
                        {t.catatan}
                      </div>

                      {/* LAMPIRAN */}
                      {t.lampiran && (
                        <div className="mb-2">
                          <a
                            href={`${process.env.REACT_APP_STORAGE_URL}/kritik_saran_up/tindak_lanjut/${t.lampiran}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-outline-primary"
                          >
                            <i className="fa fa-fw fa-paperclip me-1" />
                            Lihat Lampiran
                          </a>
                        </div>
                      )}

                      {/* STATUS */}
                      <KritikSaranStatusBadge
                        status={t.status}
                      />
                    </div>
                  </div>
                </div>
              );
            })}

          {/* EMPTY */}
          {disposisi.length === 0 &&
            tindakLanjut.length === 0 && (
              <div className="text-center text-muted py-4">
                Belum ada disposisi atau
                tindak lanjut
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default KritikSaranTimeline;